const fonts = {
  jaGothic:
    '"dnp-shuei-gothic-gin-std", "游ゴシック Medium", YuGothic, "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif',
  enGothic: '"Unbounded-custom", "Noto Sans", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif',
  enSans: '"Noto Sans", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif',
};

export default fonts;
